import { Typography } from "@mui/material";
import { FPPError, buildErrorObj } from "@newsenec/logging";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { TermsApprovalForm } from "./TermsApprovalForm";
import { UserTermsOfUse, approveTerms, useTerms } from "./termsApproval";
import { mfShorty } from "../../constants";
import { SenecScreenTemplate } from "../SenecScreenTemplate";
import { RetryScreen } from "../retry/RetryScreen";
import { ErrorSerial } from "../../ErrorSerial";

export const TermsApprovalScreen = () => {
    const { t } = useTranslation();
    const { termsOfUse, isLoading, error } = useTerms();
    const [approvalError, setApprovalError] = useState<FPPError>();

    if (!isLoading && termsOfUse && termsOfUse.signedLatest) {
        // nothing to do, restart login-flow
        window.location.reload();
    }

    const acceptTerms = useCallback(() => {
        if (!termsOfUse) {
            return;
        }

        approveTerms(termsOfUse.version)
            .then(() => window.location.reload())
            .catch((error) => setApprovalError(buildErrorObj(mfShorty, error, ErrorSerial.TERMS_APPROVAL)));
    }, [termsOfUse]);

    return approvalError || error ? (
        <RetryScreen
            data-testid="terms-approval-error-view"
            message={t("termsApprovalScreen.error.message")}
            error={approvalError ?? error}
        />
    ) : (
        <ApprovalView isLoading={isLoading} termsOfUse={termsOfUse} acceptTerms={acceptTerms} />
    );
};

export const ApprovalView = ({
    termsOfUse,
    isLoading,
    acceptTerms,
}: {
    termsOfUse?: UserTermsOfUse;
    isLoading: boolean;
    acceptTerms: () => void;
}) => {
    const { t } = useTranslation();

    return (
        <SenecScreenTemplate
            data-testid="terms-approval-view"
            title={t("termsApprovalScreen.title")}
            content={
                <>
                    <Typography>{t("termsApprovalScreen.description")}</Typography>
                    {!isLoading && termsOfUse && <TermsApprovalForm termsOfUse={termsOfUse} onSubmit={acceptTerms} />}
                </>
            }
        />
    );
};
